import React, { useState, useEffect, useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import Table from './Table';

export default function PipelinesStagesTable() {
  const [ffData, setFFData] = useState([]);
  const [hsData, setHSData] = useState([]);
  const [loading, setLoading] = useState(false);

  const tableData = hsData.flatMap(pipeline => 
    pipeline.stages.map(stage => {
      const ffMatch = ffData.find(ff => ff.identifier === stage.id);
      return {
      ff_id: ffMatch ? ffMatch.id : '-',
      ff_pipeline_id: ffMatch ? ffMatch.pipeline?.id : '-',
      hs_id: stage.id,
      hs_pipeline_label: pipeline.label,
      hs_label: stage.label,
      hs_pipeline_id: pipeline.id,
      hs_display_order: stage.displayOrder,
      hs_probability: stage.metadata?.probability,
      hs_archieved: stage.archived,
      hs_is_closed: stage.metadata?.isClosed,
      sync_status: ffMatch ? 'synced' : 'hs_only',
    }})
  );

  useEffect(() => {
    setLoading(true)
    async function fetchData() {
      const baseSearchParams = {};
      const searchParams = new URLSearchParams({ ...baseSearchParams });
      const response = await fetch("api/pipeline_stages?" + searchParams);
      const res = await response.json();
      return (res)
    }
    // call the function
    fetchData()
      .then((res) => {
        setFFData(res.ff_data || [])
        setHSData(res.hs_data || [])  
        setLoading(false)
      })
      // make sure to catch any error
      .catch(console.error);
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'sync_status',
        header: 'Sync Status',
        meta: { filterVariant: 'select'},
      },
      {
        accessorKey: 'ff_id',
        header: 'FF Stage ID',
      },
      {
        accessorKey: 'hs_id',
        header: 'HS Stage ID',
      },
      {
        accessorKey: 'hs_label',
        header: 'Label',
      },
      {
        accessorKey: 'hs_pipeline_label',
        header: 'Pipeline',
      },
      {
        accessorKey: 'ff_pipeline_id',
        header: 'FF Pipeline ID',
      },
      {
        accessorKey: 'hs_pipeline_id',
        header: 'HS Pipeline ID',
      },
      {
        accessorKey: 'hs_display_order',
        header: 'Display Order',
      },
      {
        accessorKey: 'hs_probability',
        header: 'Probability',
      },
      {
        accessorFn: (row) => (row.archived ? 'Yes' : 'No'),
        header: 'Archived',
        meta: { filterVariant: 'select' },
      },
      {
        accessorFn: (row) => (row.is_closed ? 'Yes' : 'No'),
        header: 'Is Closed',
        meta: { filterVariant: 'select' },
      },
    ],
    []
  );

  return (
    <div className="border bg-white p-3">
      <Table
        loadingFFData={loading}
        loadingHubspotData={false}
        data={tableData}
        columns={columns}
        autoResetPageIndex={false}
      />
    </div>
  );
};

const element = document.getElementById('pipeline-stages-table');
if (element) {
  const root = createRoot(element);
  root.render(<PipelinesStagesTable/>);
}
